export { default as CloseButton } from './CloseButton'
export { default as StyledCloseButton } from './CloseButton.Styled'